/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const FETCH_RECIPES = "FETCH_RECIPES";
export const SET_RECIPES = "SET_RECIPES";
export const SET_ORIGINAL_RECIPE = "SET_ORIGINAL_RECIPE";
export const FETCH_PRICE = "FETCH_PRICE";
export const SET_IMAGE_URLS = "SET_IMAGE_URLS";
export const SET_PRICES = "SET_PRICES";
export const SET_DESIGN_DATA = "SET_DESIGN_DATA";
export const SET_IS_PERSONALIZATION_INVALID = "SET_IS_PERSONALIZATION_INVALID";
export const CLEAN_DESIGN_DATA = "CLEAN_DESIGN_DATA";
export const IS_CUSTOMIZER_TRANSFERRED_MODEL = "IS_CUSTOMIZER_TRANSFERRED_MODEL"
